export const RoutingDictionaryForMobileNav = {
  Dashboard: { enum: 1, route: '/dashboard' },
  Landing: { enum: 2, route: '/landing' },
  BookOnline: { enum: 3, route: '/book-online' },
  Appointments: { enum: 4, route: '/appointments' },
  Documents: { enum: 5, route: '/forms/list' },
  Education: { enum: 6, route: '/contents/list' },
  Reports: { enum: 7, route: '/reports/list' },
  PlanOfCare: { enum: 8, route: '/plansCare/list' },
  VitalSigns: { enum: 9, route: '/vitals' },
  OutcomeMeasures: { enum: 10, route: '/outcomes' },
  ExercisePrograms: { enum: 11, route: '/exercise-programs' },
  Billing: { enum: 12, route: '/invoices' },
  SecureMessaging: { enum: 13, route: '/secured-messaging' },
  GiftCertificates: { enum: 14, route: '/store' },
  Feedback: { enum: 15, route: '/feedbacks' },
  AppointmentsConfirmPresence: { enum: 16, route: '/appointments/confirm-presence' },
  DocumentsToSign: { enum: 17, route: '/forms/list/tosign' },
  DocumentsToFill: { enum: 18, route: '/forms/list/tofill' },
  BookOnlineFollowUps: { enum: 19, route: '/book-online/follow-ups' },
};
